import { Check } from "lucide-react"

/**
 * What the agent did, in the merchant's words. Operator diagnostics show every raw call;
 * this is the onboarding view, so repeated calls to the same tool collapse into one line
 * and a tool with no wording of its own is skipped rather than named internally.
 */
const TOOL_ACTIVITY_LABELS: Record<string, string> = {
  search_shopify_catalog: "Searched your catalog",
  search_shopify_policies: "Checked your store policies",
  get_shopify_order: "Looked up an order",
  check_calendar_availability: "Checked the calendar",
  book_calendar_meeting: "Booked a meeting",
  capture_customer_info: "Saved contact details",
  human_handover: "Escalated to your team",
  email_forward: "Forwarded the email",
}

export function ToolActivity({ calls }: { calls: { name: string }[] }) {
  const activities = [...new Set(calls.map((call) => TOOL_ACTIVITY_LABELS[call.name]))].filter(
    Boolean,
  )
  if (activities.length === 0) return null

  return (
    <ul className="mt-2 flex flex-wrap gap-1.5">
      {activities.map((activity, index) => (
        <li
          key={activity}
          style={{ animationDelay: `${index * 90}ms` }}
          className="inline-flex animate-in items-center gap-1 rounded-full border border-gray-200/70 bg-white/50 px-1.5 py-0.5 text-[11px] leading-4 text-gray-500/90 fade-in slide-in-from-bottom-1 fill-mode-both"
        >
          <Check aria-hidden="true" className="h-2.5 w-2.5 text-emerald-600/70" />
          {activity}
        </li>
      ))}
    </ul>
  )
}
